import(/* webpackMode: "eager", webpackExports: ["AffordabilityCalculator"] */ "/vercel/path0/web/components/forms/affordability-calculator.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/next/dist/client/link.js");
